var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.578 6.10168C22.6997 5.91501 20.8214 5.77501 18.9314 5.67001V5.65834L18.6747 4.14168C18.4997 3.06834 18.243 1.45834 15.513 1.45834H12.4564C9.73802 1.45834 9.48136 2.99834 9.29469 4.13001L9.04969 5.62334C7.96469 5.69334 6.87969 5.76334 5.79469 5.86834L3.41469 6.10168C2.92469 6.14834 2.57469 6.58001 2.62136 7.05834C2.66803 7.53668 3.08803 7.88668 3.57803 7.84001L5.95803 7.60668C12.0714 7.00001 18.2314 7.23334 24.4147 7.85168C24.4497 7.85168 24.473 7.85168 24.508 7.85168C24.9514 7.85168 25.3364 7.51334 25.383 7.05834C25.418 6.58001 25.068 6.14834 24.578 6.10168Z",
    fill: "#07506D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4331 9.49666C22.1531 9.20499 21.7681 9.04166 21.3714 9.04166H6.62475C6.22808 9.04166 5.83141 9.20499 5.56308 9.49666C5.29475 9.78832 5.14308 10.185 5.16641 10.5933L5.88975 22.5633C6.01808 24.3367 6.18141 26.5533 10.2531 26.5533H17.7431C21.8147 26.5533 21.9781 24.3483 22.1064 22.5633L22.8297 10.605C22.8531 10.185 22.7014 9.78832 22.4331 9.49666ZM15.9347 20.7083H12.0497C11.5714 20.7083 11.1747 20.3117 11.1747 19.8333C11.1747 19.355 11.5714 18.9583 12.0497 18.9583H15.9347C16.4131 18.9583 16.8097 19.355 16.8097 19.8333C16.8097 20.3117 16.4131 20.7083 15.9347 20.7083ZM16.9147 16.0417H11.0814C10.6031 16.0417 10.2064 15.645 10.2064 15.1667C10.2064 14.6883 10.6031 14.2917 11.0814 14.2917H16.9147C17.3931 14.2917 17.7897 14.6883 17.7897 15.1667C17.7897 15.645 17.3931 16.0417 16.9147 16.0417Z",
    fill: "#116584"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic-trash.9ccfb34f5de95305548243850dfb3155.svg";
export { ForwardRef as ReactComponent };